import { MessageModel } from './message.model';
import { User } from './user';

export class InboxModel {
  public id: number;
  public mensajesId: MessageModel;
  public usuarioId: User;
  public fechaLeido: Date;

  public readed: boolean;

  constructor() {
    this.id = 0;
    this.mensajesId = new MessageModel();
    // this.usuarioId = new Usuario();
    this.fechaLeido = null;
    this.readed = false;
  }

  isUnread(): boolean {
    return this.fechaLeido == null;
  }

  isPaymentLink(): boolean {
    return this.mensajesId.mensaje.startsWith('http://');
  }

  getIcon(): string {
    return this.isUnread() ? 'mail' : 'drafts';
  }

  getStyle(): string {
    return this.isUnread() ? 'unread' : '';
  }

  getTitle(): string {
    return this.mensajesId.titulo;
  }

  getMessage(): string {
    return this.mensajesId.mensaje;
  }

  getDate(): string {
    return this.mensajesId.fechaDesde.toLocaleDateString();
  }

  getRawDate(): Date {
    return this.mensajesId.fechaDesde;
  }

  getReadDate(): string {
    return this.fechaLeido.toLocaleDateString();
  }

  setReadDate(date: Date): void {
    this.fechaLeido = date;
    this.readed = true;
  }

  getRawReadDate(): Date {
    return this.fechaLeido;
  }

  markAsReaded(): void {
    this.readed = true;
    this.fechaLeido = new Date();
  }
}
